import { PublicClientApplication } from '@azure/msal-browser';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import axios from 'axios';
import { msalConfig } from '../azureConfig';
import { getExpirationDate } from '../helpers/utils';
import { config, TOKEN_KEY } from '../constants/common';

const clientWinAuth = axios.create({
  baseURL: config.url.WIN_AUTH_URL,
});

export const msalInstance = new PublicClientApplication(msalConfig);

export const scopeForAzureADUser = ['User.Read', 'api://f3b788ef-b965-433a-ba89-ae071e313683/access_as_user'];

// When this func executes, the isAzureAuthenticated hook returns 'true', and actions in App.js && Router/index.js completes
export const azureADLogin = () => {
  msalInstance
    .loginPopup({
      scopes: scopeForAzureADUser,
      redirectUri: window.location.origin,
    })
    .catch(error => {
      if (process.env.NODE_ENV === 'development') {
        console.error(error);
      }
    });
};

// When this func executes, the isAzureAuthenticated hook returns 'false', and actions in App.js && Router/index.js completes
export const azureADLogout = async () => {
  await msalInstance.logoutPopup({
    postLogoutRedirectUri: '/',
  });
};

export const retrieveBarearToken = async (AzureADToken: any) => {
  const { status, data } = await clientWinAuth.post('/login', null, {
    headers: {
      Authorization: `Bearer ${AzureADToken.idToken}`,
    },
    withCredentials: true,
  });

  if (status !== 200) {
    toast.error('Network error. Try to reload application');
  }

  Cookies.set(TOKEN_KEY, data, { sameSite: 'strict', expires: getExpirationDate() });
};
